import React from 'react';
import PropTypes from 'prop-types';

import ListingIconButton from "components/Product/Table/ListingIconButton";

import {ReactComponent as Refresh} from "assets/img/refresh.svg";

ListingRefreshButton.propTypes = {
    tooltip: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

function ListingRefreshButton(props) {
    return <ListingIconButton icon={Refresh} {...props}/>;
}

export default ListingRefreshButton;
